
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Puneairporttoshirdicab() {



    const cardData =
    {
        keyword: 'Pune Airport to Shirdi Cab',
        heading: 'Meghana Cab : Pune Airport to Shirdi Cab',
        headingDescription: 'Meghana Cab offers seamless Pune Airport to Shirdi Cab services, providing you with a comfortable, safe, and stress-free ride directly from the airport to the holy city. Whether you are arriving for darshan, a pilgrimage trip, or a family visit, our clean and well-maintained vehicles and professional drivers ensure a smooth journey. Enjoy transparent pricing, easy online booking, and dependable curbside pickup at the airport. With on-time service, flexible scheduling, and 24/7 customer support, Meghana Cab is your trusted partner for convenient and reliable travel from Pune Airport to Shirdi. Book now and experience peace of mind on your sacred journey.',


        top: 'Top Places to Visit in Shirdi with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a significant historical landmark located in the heart of Pune. This majestic fort once served as the seat of Peshwa power and showcases stunning Maratha architecture, large wooden gates, intricate courtyards, and fortified bastions. Though much of it was destroyed in a fire, the remains reflect its grandeur, and the evening light and sound show narrating its history draws many visitors."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892 by Sultan Aga Khan III, holds a pivotal place in India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other national leaders during the Quit India Movement. The palace is set amidst sprawling gardens and houses a museum with rare photos and personal belongings of Gandhi, making it a place of historical and emotional importance for visitors."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located around 30 km from Pune, Sinhagad Fort stands as a symbol of Maratha valor and history. The fort played a key role in the Battle of Sinhagad in 1670, where Tanaji Malusare fought valiantly for Shivaji Maharaj. The fort offers trekking trails, breathtaking views of the Sahyadri mountains, and traditional food stalls serving local dishes like pithla bhakri to reward visitors after the climb."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This fascinating museum is home to over 20,000 artifacts collected by Dr. Dinkar Kelkar, reflecting the rich and diverse cultural heritage of India. The collection includes antique musical instruments, weapons, intricate carvings, traditional household items, and unique sculptures from various time periods. The museum provides an educational experience that connects visitors to India’s artistic and domestic past."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century rock-cut shrine dedicated to Lord Shiva, the Pataleshwar Cave Temple is an archaeological gem located in central Pune. Carved out of a single basalt rock, it features finely crafted pillars, a sanctum with a Shiva Lingam, and a circular Nandi Mandapa. Its peaceful surroundings offer a meditative atmosphere for visitors looking to explore ancient architecture in a calm setting."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, this world-renowned retreat founded by spiritual leader Osho offers a variety of meditation and wellness programs. Spread across lush green landscapes with zen-style architecture and tranquil energy, the resort attracts spiritual seekers from around the world. Daily meditation sessions, therapy workshops, and a serene environment make it an ideal place to rejuvenate mentally and physically."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, located about 20 km from Pune, is a favorite weekend destination for families and couples seeking relaxation near nature. Built on the Mutha River, the dam offers cool breezes, scenic views of the water and surrounding hills, and small eateries serving local snacks. It is also the site of the National Defence Academy, making it an important landmark near Pune."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by the famous Korakuen Garden in Okayama, Japan, this well-manicured garden located on Sinhagad Road offers a beautiful blend of Japanese landscaping and Indian greenery. Waterfalls, streams, bridges, and floral layouts make it a peaceful place for families, morning walkers, and photographers seeking natural beauty within the city."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic monument built by Shahaji Bhosale for his son Shivaji Maharaj in the 1630s. Though the original structure was destroyed, the current reconstructed version serves as a museum that reflects Shivaji’s early life through paintings, weapons, and historical narratives. It is an essential stop for anyone interested in Maratha history and legacy."
  },
  {
    "title": "Fergusson College Road",
    "description": "A vibrant street in the Deccan area, Fergusson College Road is known for its youthful energy, thanks to the presence of several colleges nearby. It features a lively mix of cafes, fashion boutiques, bookstores, and street food joints. Whether you’re shopping for trendy clothes or enjoying a plate of momos, this road captures the essence of Pune’s modern-day culture and lifestyle."
  }
],

"services": [
    {
        "name": "Book Cab Pune Airport to Shirdi",
        "description": "Book a reliable cab from Pune Airport to Shirdi with Meghana Cab for a smooth and comfortable journey. Whether you’re visiting for a religious pilgrimage or a family trip, we offer quick pickups, courteous drivers, and well-maintained vehicles to ensure your journey begins stress-free."
    },
    {
        "name": "Airport Pickup to Shirdi Cab",
        "description": "Meghana Cab provides prompt airport pickup services from Pune Airport to Shirdi. Our professional drivers are punctual and ensure timely pickups, so you can relax as your trip to the sacred Shirdi Sai Baba Temple begins right from the terminal gate."
    },
    {
        "name": "Pune Airport to Shirdi One Way Taxi",
        "description": "Looking for a one-way taxi from Pune Airport to Shirdi? Meghana Cab offers budget-friendly and comfortable one-way trips, ideal for solo travelers, families, or groups. Enjoy flexible booking and clear fare structures with no hidden fees."
    },
    {
        "name": "Pune Airport to Shirdi Round Trip Cab",
        "description": "Planning a same-day return or next-day trip back? Meghana Cab’s round trip cab service from Pune Airport to Shirdi ensures round-the-clock convenience, comfort, and cost-efficiency for pilgrims and tourists alike."
    },
    {
        "name": "AC Taxi Pune Airport to Shirdi",
        "description": "Travel in comfort with Meghana Cab’s air-conditioned taxis from Pune Airport to Shirdi. Our clean and cool sedans and SUVs provide a refreshing journey even in peak summer, making your long-distance ride soothing and pleasant."
    },
    {
        "name": "Outstation Cab Pune Airport to Shirdi",
        "description": "Book an outstation cab from Pune Airport to Shirdi with Meghana Cab for hassle-free intercity travel. Our experienced chauffeurs and spacious vehicles ensure a safe and relaxed journey to one of Maharashtra’s most visited pilgrimage destinations."
    },
    {
        "name": "SUV Taxi Airport to Shirdi Trip",
        "description": "Travel with family or in a group? Meghana Cab offers SUV taxi services from Pune Airport to Shirdi for a more spacious and comfortable ride. Perfect for families, pilgrims, or group tours seeking both comfort and affordability."
    },
    {
        "name": "Budget Cab Pune Airport to Shirdi",
        "description": "Meghana Cab offers affordable and value-for-money taxi options from Pune Airport to Shirdi. Choose from hatchbacks or compact sedans to match your budget without compromising on reliability or comfort."
    },
    {
        "name": "Shirdi Temple Taxi from Pune Airport",
        "description": "Heading straight to the holy Shirdi Temple? Book your temple taxi with Meghana Cab directly from Pune Airport. Our experienced drivers know the route well and ensure you reach the temple comfortably and on time for darshan."
    },
    {
        "name": "Sedan Hire Pune Airport to Shirdi",
        "description": "Hire a sedan for a classy and comfortable ride from Pune Airport to Shirdi. Meghana Cab provides clean, well-equipped sedans for smooth highway travel, ideal for business travelers, couples, or small families."
    },
    {
        "name": "Pune Airport to Shirdi Travel by Car",
        "description": "Enjoy the flexibility of traveling from Pune Airport to Shirdi by private car with Meghana Cab. Avoid the stress of public transport and enjoy a relaxed journey tailored to your schedule and comfort preferences."
    },
    {
        "name": "Online Booking Airport to Shirdi Cab",
        "description": "Book your cab online from Pune Airport to Shirdi in just a few clicks with Meghana Cab. Our easy-to-use platform allows you to select vehicle types, view fares, and confirm your trip instantly with real-time updates and confirmation."
    },
    {
        "name": "Premium Airport Cab Pune to Shirdi",
        "description": "For travelers seeking a more luxurious experience, Meghana Cab offers premium airport cabs from Pune to Shirdi. Ride in style with top-end sedans or SUVs featuring enhanced comfort and elite chauffeur service."
    },
    {
        "name": "Affordable Pune Airport to Shirdi Fare",
        "description": "Get the most competitive fares from Pune Airport to Shirdi with Meghana Cab. Our pricing is transparent and includes tolls and taxes, ensuring you get top service at a reasonable price with no hidden costs."
    },
    {
        "name": "Chauffeur Cab Pune Airport to Shirdi",
        "description": "Experience the difference with Meghana Cab’s chauffeur-driven cabs from Pune Airport to Shirdi. Our professional drivers ensure a safe, comfortable, and courteous ride, perfect for business, family, or religious travelers."
    }
],

"tableData": [
    ["Book Cab Pune Airport to Shirdi", "Airport Pickup to Shirdi Cab"],
    ["Pune Airport to Shirdi One Way Taxi", "Pune Airport to Shirdi Round Trip Cab"],
    ["AC Taxi Pune Airport to Shirdi", "Outstation Cab Pune Airport to Shirdi"],
    ["SUV Taxi Airport to Shirdi Trip", "Budget Cab Pune Airport to Shirdi"],
    ["Shirdi Temple Taxi from Pune Airport", "Sedan Hire Pune Airport to Shirdi"],
    ["Pune Airport to Shirdi Travel by Car", "Online Booking Airport to Shirdi Cab"],
    ["Premium Airport Cab Pune to Shirdi", "Affordable Pune Airport to Shirdi Fare"],
    ["Chauffeur Cab Pune Airport to Shirdi", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Convenient Pune Airport to Shirdi Cab Service",
        "WhyChoosedescription": "Meghana Cab provides seamless cab transfers from Pune Airport to Shirdi, ensuring a stress-free experience from the moment you land. Ideal for pilgrims, families, and out-of-town visitors heading straight to the Sai Baba temple or nearby accommodations."
    },
    {
        "WhyChooseheading": "Airport Pickup with Real-Time Flight Monitoring",
        "WhyChoosedescription": "Our team tracks your flight status in real time, so your driver is always ready when you arrive—no waiting, no confusion. We assist with luggage and offer smooth exit navigation from Pune Airport to start your trip toward Shirdi comfortably."
    },
    {
        "WhyChooseheading": "Multiple Cab Options to Suit Your Needs",
        "WhyChoosedescription": "Choose from well-maintained sedans, SUVs, tempo travellers, or luxury cars based on your group size and comfort preferences. Each cab is equipped with air conditioning, ample luggage space, and clean interiors for a relaxed long-distance ride."
    },
    {
        "WhyChooseheading": "Professional Drivers Familiar with the Route",
        "WhyChoosedescription": "Our trained drivers are experienced in airport pickups and long-distance routes. They take the safest and quickest path to Shirdi via Ahmednagar Highway or alternate routes based on traffic and road conditions."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "Get fair, fixed-rate pricing for Pune Airport to Shirdi cab rides with no hidden charges. Our fare includes tolls, driver allowance, and taxes so you can focus on your journey without worrying about unexpected costs."
    },
    {
        "WhyChooseheading": "24/7 Service for Early Morning or Late-Night Flights",
        "WhyChoosedescription": "No matter what time your flight lands, Meghana Cab is available 24/7 to provide reliable transportation from Pune Airport to Shirdi, even during holidays and weekends."
    },
    {
        "WhyChooseheading": "One-Way and Round Trip Options Available",
        "WhyChoosedescription": "We offer both one-way and round trip cabs from Pune Airport to Shirdi. Whether you're planning a same-day return or an extended temple stay, we tailor the service to your schedule."
    },
    {
        "WhyChooseheading": "Instant Booking with Live Driver Tracking",
        "WhyChoosedescription": "Book instantly through our app, website, or phone call. Get confirmation, driver contact details, and live location tracking so you’re always in control of your journey."
    }
]









































    }

const faqData = [
    {
        question: "How can I book a cab from Pune Airport to Shirdi with Meghana Cab?",
        answer: "You can book a Pune Airport to Shirdi cab by calling Meghana Cab at +91 9075462128 or through our website."
    },
    {
        question: "What types of vehicles are available for Pune Airport to Shirdi trips?",
        answer: "We offer sedans, SUVs, and tempo travellers depending on your group size and comfort needs."
    },
    {
        question: "Is Meghana Cab available 24/7 for Pune Airport to Shirdi bookings?",
        answer: "Yes, our service operates round-the-clock to accommodate your travel schedule."
    },
    {
        question: "Can I book a one-way or round-trip cab from Pune Airport to Shirdi?",
        answer: "Yes, Meghana Cab provides both one-way and round-trip services."
    },
    {
        question: "What is included in the Pune Airport to Shirdi cab fare?",
        answer: "The fare includes driver charges, fuel, tolls, and vehicle maintenance. Additional charges may apply based on your trip."
    },
    {
        question: "Are Meghana Cab vehicles sanitized for safety?",
        answer: "Yes, all vehicles are regularly cleaned and sanitized to ensure your safety and comfort."
    },
    {
        question: "Do the drivers know the best routes from Pune Airport to Shirdi?",
        answer: "Yes, our experienced drivers are familiar with the best routes for a timely and safe journey."
    },
    {
        question: "What payment methods are accepted for Pune Airport to Shirdi cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "Can I request a child seat or other special requirements?",
        answer: "Yes, special requests can be made at the time of booking."
    },
    {
        question: "How can I contact Meghana Cab for Pune Airport to Shirdi cab services?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Pune Airport to Shirdi cab services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Anil Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Pune Airport to Shirdi cab service by Meghana Cab was punctual and very comfortable.”',
    },
    {
        name: 'Ms. Rekha Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service and friendly driver made our trip from Pune Airport to Shirdi very smooth.”',
    },
];





































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Airport to Shirdi Cab",
  "image": "https://www.meghanacabs.com/assets/images/pune-airport-to-shirdi-cab.jpg",
  "description": "Book Pune Airport to Shirdi cab with Meghana Cabs for a comfortable, one-way or round trip. AC sedans, SUVs, and budget options available with experienced drivers and on-time service.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6129"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-airport-to-shirdi-cab"
  }
};







    return (
        <div>
<Helmet>
  <title>Pune Airport to Shirdi Cab | One Way & Round Trip Taxi</title>
  <meta 
    name="description" 
    content="Book Pune Airport to Shirdi cab with Meghana Cabs for a comfortable, one-way or round trip. AC sedans, SUVs, and budget options available with experienced drivers and on-time service." 
  />
  <meta 
    name="keywords" 
    content="Book Cab Pune Airport to Shirdi, Airport Pickup to Shirdi Cab, Pune Airport to Shirdi One Way Taxi, Pune Airport to Shirdi Round Trip Cab, AC Taxi Pune Airport to Shirdi, Outstation Cab Pune Airport to Shirdi, SUV Taxi Airport to Shirdi Trip, Budget Cab Pune Airport to Shirdi, Shirdi Temple Taxi from Pune Airport, Sedan Hire Pune Airport to Shirdi, Pune Airport to Shirdi Travel by Car, Online Booking Airport to Shirdi Cab, Premium Airport Cab Pune to Shirdi, Affordable Pune Airport to Shirdi Fare, Chauffeur Cab Pune Airport to Shirdi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/34.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Puneairporttoshirdicab;